import React from 'react';
import {NewPage} from './Tools'


import marked from 'marked';
import yaml from 'js-yaml';

import lists from "./lists";

import "./code.css";
import "highlight.js/styles/atom-one-light.css";


marked.setOptions({
  renderer: new marked.Renderer(),
  highlight: function(code) {
    const hljs = require('highlight.js');
    var str='';
    var splitCode = code.split("\n");
    var i;
    for (i=0;i<splitCode.length;i++)
      str=str+"<li key="+i+"><span>"+hljs.highlight("cpp",splitCode[i]).value+"\n</span></li>";
    //return str;
    return "<ol>" + str +"</ol>";
  },
  pedantic: false,
  gfm: true,
  breaks: false,
  sanitize: false,
  smartLists: true,
  smartypants: false,
  xhtml: false
});

class Article extends React.Component {
  constructor(props) {
    super(props);
    this.state={article:""};
  }

  updateArticle() {
    const path = this.props.match.url;
    fetch("/source"+path+".md")
      .then((res)=>{return res.text();})
      .then((res)=>{
        var pos = res.indexOf('---',3);
        var str1 = res.substr(0,pos);
        var str2 = res.substr(pos+3);
        //console.log(str2);
        this.setState(yaml.safeLoad(str1));
        this.setState({article:str2});
      });
  }

  componentDidMount() {
    try {
      window.MathJax.startup.document.state(0);
      window.MathJax.texReset();
      window.MathJax.typeset();
    }catch(err){};
    //console.log(this);
    this.updateArticle();
  }
  
  componentDidUpdate(prevProps) {
    try {
      window.MathJax.startup.document.state(0);
      window.MathJax.texReset();
      window.MathJax.typeset();
    }catch(err){};
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.updateArticle();
    }
  }

  render() {
    var pos; var bottoms;
    pos = lists.article.findIndex( (x)=> {return '/'+x.url===this.props.match.url;} );
    bottoms = ['',''];
    if (pos!==0) bottoms[0]=<NewPage className="Link" to={"/"+lists.article[pos-1].url} style={{"float":"left"}}>下一篇</NewPage>;
    if (pos!==lists.article.length-1) bottoms[1]=<NewPage className="Link" to={"/"+lists.article[pos+1].url} style={{"float":"right"}}>上一篇</NewPage>;
    return (
      <div>
        <h1>{this.state.title}</h1>
        <hr/>
        <div dangerouslySetInnerHTML={{ __html: marked(this.state.article) }}/>
        <hr style={{"marginTop":"50px","marginBottom":"10px"}}/>
        {bottoms}
        <div style={{"clear":"both"}}/>
      </div>
    );
  }
}

export default Article;